function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import concat from 'lodash/concat';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { ButtonEl } from 'common/components/button';
import { SvgIconEl } from 'common/components/svg-icon';
import { IconSizeType } from 'common/constants';
import { SelectEl } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonTheme } from 'common/components/button/constants';
import { ProjectTeam } from 'common/types/app-api/project-team';
import { MixpanelUserItem } from '../user-list/types';
import { UserListEl } from '../user-list';
import { UserIconEl } from '../user-icon';
import { getUserNameLabel } from './utils';
import css from './index.inline.styl';
export type UserSelectorParams = {
  users?: MixpanelUserItem[];
  selectedUsers?: string[];
  teams?: ProjectTeam[];
  selectedTeams?: string[];
  icon?: string;
  label?: string;
  searchPlaceholder?: string;
  singleSelect?: boolean;
  disableSelect?: boolean;
  hasSaveButton?: boolean;
  buttonTriggerText?: string;
  onSelectedUsersChange?: (d) => void;
  onSelectedTeamsChange?: (d) => void;
  onMenuChange?: (d) => void;
  saveClicked?: () => void;
  buttonStyleOverride?: string;
};
export type JsxProps = {
  params: UserSelectorParams;
};
// users that are selected after menu close/open
type UserSelectorState = {
  committedSelectedUsers?: string[];
  committedSelectedTeams?: string[];
};
type UserItem = {
  isSelected: boolean;
  label: string;
  value: string;
  user: MixpanelUserItem;
  type: string;
};
type TeamItem = {
  isSelected: boolean;
  label: string;
  value: string;
  team: ProjectTeam;
  type: string;
};
const UsersSelectTrigger = (_ref: {
  cmp: UserSelector;
}) => {
  let {
    cmp
  }: {
    cmp: UserSelector;
  } = _ref;
  const selectedUsersList = cmp.getSelectedUsersList();
  // TODO: Maybe create a separate component that supports both users and teams and keep the name in line with what it does - Remy 06/10/2025
  const selectedTeamsList = cmp.getSelectedTeamsList();
  const selectedItemsList = [...selectedUsersList, ...selectedTeamsList];
  let suffix = "";
  if ((selectedItemsList === null || selectedItemsList === void 0 ? void 0 : selectedItemsList.length) === 1) {
    suffix = selectedItemsList[0].name;
  }
  return <div sel='.users-select-trigger' attrs={{
    slot: "trigger"
  }} data-sentry-component="UsersSelectTrigger" data-sentry-source-file="index.tsx">
      {cmp.params.buttonTriggerText ? <ButtonEl attrs={{
      theme: ButtonTheme.Secondary,
      role: "button"
    }}>
          {cmp.params.buttonTriggerText}
        </ButtonEl> : <ButtonEl sel='.trigger-button' attrs={{
      'style-override': cmp.params.buttonStyleOverride
    }}>
          <div sel='.trigger-label'>
            {cmp.params.icon ? <SvgIconEl sel='.trigger-icon' attrs={{
          icon: cmp.params.icon
        }} /> : null}
            {cmp.params.label ? <div sel='.trigger-label-text'>{cmp.params.label}</div> : null}
            {selectedItemsList !== null && selectedItemsList !== void 0 && selectedItemsList.length ? <div>
                <UserListEl sel='.trigger-users' attrs={{
            users: selectedItemsList,
            size: IconSizeType.Small,
            'max-icons-displayed': 4,
            elref: "userList"
          }} />
              </div> : null}
            {suffix && <div sel='.trigger-label-suffix'>{suffix}</div>}
            <SvgIconEl sel='.trigger-caret' attrs={{
          icon: "caret-down"
        }} />
          </div>
        </ButtonEl>}
    </div>;
};
export class UserSelector extends ParamComponent<UserSelectorParams, UserSelectorState> {
  get config() {
    return {
      params: {
        users: Array,
        teams: Array,
        singleSelect: Boolean,
        selectedUsers: Array,
        selectedTeams: Array,
        icon: String,
        label: String,
        searchPlaceholder: String,
        onSelectedUsersChange: Function,
        onSelectedTeamsChange: Function,
        onMenuChange: Function,
        disableSelect: Boolean,
        hasSaveButton: Boolean,
        saveClicked: Function,
        buttonTriggerText: String,
        buttonStyleOverride: String
      },
      defaultState: {
        committedSelectedUsers: [],
        committedSelectedTeams: [],
        singleSelect: false
      },
      css,
      useShadowDom: true,
      template: () => {
        return <div sel='.user-selector-container'>
            {this.params.disableSelect ? <UserListEl sel='.trigger-users' attrs={{
            users: [...this.getSelectedUsersList(), ...this.getSelectedTeamsList()],
            size: IconSizeType.Small,
            'max-icons-displayed': 4,
            elref: "userList"
          }} /> : <SelectEl sel='.user-selector' attrs={_objectSpread({
            multiple: !this.params.singleSelect,
            'multiple-save-button': this.params.hasSaveButton,
            'search-placeholder': this.params.searchPlaceholder,
            elref: "creatorSelect",
            theme: SelectTheme.Secondary
          }, this.params.buttonTriggerText ? {
            'menu-width': 300
          } : {})} props={{
            sections: this.getUserSelectorSections()
          }} on={{
            change: ev => {
              ev.detail.item.type === "user" ? this.params.onSelectedUsersChange(ev.detail.item) : this.params.onSelectedTeamsChange(ev.detail.item);
            },
            menuChange: ev => {
              var _this$params$onMenuCh, _this$params;
              // If selected item is a user update committed selected users
              this.update({
                committedSelectedUsers: this.params.selectedUsers
              });
              // if it's a team update committed selected teams
              this.update({
                committedSelectedTeams: this.params.selectedTeams
              });
              (_this$params$onMenuCh = (_this$params = this.params).onMenuChange) === null || _this$params$onMenuCh === void 0 || _this$params$onMenuCh.call(_this$params, ev.detail.isOpen);
            },
            saveClicked: this.params.saveClicked
          }}>
                <UsersSelectTrigger cmp={this} />
              </SelectEl>}
          </div>;
      }
    };
  }
  getSelectedTeamsList() {
    var _this$params$teams;
    return ((_this$params$teams = this.params.teams) === null || _this$params$teams === void 0 ? void 0 : _this$params$teams.filter(team => {
      var _this$params$selected;
      return (_this$params$selected = this.params.selectedTeams) === null || _this$params$selected === void 0 ? void 0 : _this$params$selected.includes(team.id.toString());
    })) || [];
  }
  getSelectedUsersList() {
    var _this$params$users;
    return (_this$params$users = this.params.users) === null || _this$params$users === void 0 ? void 0 : _this$params$users.filter(user => this.params.selectedUsers.includes(user.email));
  }
  getUserSelectorSections() {
    var _this$params2, _this$params$teams2, _this$params$teams3;
    if (!((_this$params2 = this.params) !== null && _this$params2 !== void 0 && (_this$params2 = _this$params2.users) !== null && _this$params2 !== void 0 && _this$params2.length)) {
      return [];
    }
    // pushing commited selected users to top
    const committedUserItems: UserItem[] = this.params.users.filter(user => this.state.committedSelectedUsers.includes(user.email)).map(user => ({
      isSelected: this.params.selectedUsers.includes(user.email),
      label: getUserNameLabel(user),
      value: user.email,
      user,
      type: "user"
    }));
    const uncommittedUserItems: UserItem[] = this.params.users.filter(user => !this.state.committedSelectedUsers.includes(user.email)).map(user => ({
      isSelected: this.params.selectedUsers.includes(user.email),
      label: getUserNameLabel(user),
      value: user.email,
      user,
      type: "user"
    }));
    const committedTeamItems: TeamItem[] = ((_this$params$teams2 = this.params.teams) === null || _this$params$teams2 === void 0 ? void 0 : _this$params$teams2.filter(team => this.state.committedSelectedTeams.includes(team.id.toString())).map(team => ({
      isSelected: this.params.selectedTeams.includes(team.id.toString()),
      label: team.name,
      value: team.id.toString(),
      team,
      type: "team"
    }))) || [];
    const uncommittedTeamItems: TeamItem[] = ((_this$params$teams3 = this.params.teams) === null || _this$params$teams3 === void 0 ? void 0 : _this$params$teams3.filter(team => !this.state.committedSelectedTeams.includes(team.id.toString())).map(team => ({
      isSelected: this.params.selectedTeams.includes(team.id.toString()),
      label: team.name,
      value: team.id.toString(),
      team,
      type: "team"
    }))) || [];
    const items: Array<TeamItem | UserItem> = concat(committedUserItems as Array<TeamItem | UserItem>, committedTeamItems, uncommittedTeamItems, uncommittedUserItems);
    return [{
      items,
      iconRenderer: item => {
        const isUser = item.type === "user";
        const attrs = {
          id: isUser ? item.user.id : parseInt(item.value),
          email: isUser ? item.user.email : "",
          name: isUser ? item.user.name : item.team.name,
          size: IconSizeType.Small,
          'disable-tooltip': true,
          'disable-sidebar': true
        };
        return <UserIconEl style={{
          'margin-right': "6px"
        }} attrs={attrs} />;
      }
    }];
  }
  connectedCallback() {
    super.connectedCallback();
  }
}
export const UserSelectorEl = defineAndMakeJsxFactory<JsxProps>("mp-user-selector", UserSelector);
export const UserSelectorReact = panel2react<JsxProps>("mp-user-selector", UserSelector);